import QAndABuyerContainer from './QAndABuyerContainer.component';

export default QAndABuyerContainer;